{
  "nav": {
    "home": "社群主頁",
    "articles": "新聞與文章",
    "events": "卡展活動",
    "dealers": "商戶名錄"
  },
  "layout": {
    "breadcrumbHome": "主頁",
    "breadcrumbCommunity": "社群",
    "eyebrow": "社群中心",
    "title": "新聞、卡展與英國商戶",
    "subtitle": "英國集換卡界的一切動態 — 由 BidNova Auctions 精心策劃。"
  },
  "home": {
    "tiles": {
      "articlesTitle": "新聞與文章",
      "articlesDesc": "市場趨勢與入門攻略",
      "eventsTitle": "英國卡展",
      "eventsDesc": "即將舉行的活動與比賽",
      "dealersTitle": "商戶名錄",
      "dealersDesc": "信譽良好的英國卡店",
      "explore": "立即瀏覽"
    },
    "articlesEyebrow": "市場趨勢、入門攻略與社群故事",
    "articlesTitle": "最新新聞與攻略",
    "eventsEyebrow": "交易之夜、比賽與送評聚會",
    "eventsTitle": "英國卡展預告",
    "dealersEyebrow": "信譽良好的英國卡店、玩具店與網店",
    "dealersTitle": "精選商戶",
    "viewAll": "查看全部 →",
    "readMore": "閱讀更多",
    "emptyArticles": "文章即將推出。",
    "emptyEvents": "暫時未有活動 — 請留意後續更新。",
    "emptyDealers": "商戶名錄即將推出。"
  },
  "articles": {
    "index": {
      "title": "新聞與文章",
      "subtitle": "來自英國集換卡社群的市場趨勢、入門攻略與故事。",
      "searchPlaceholder": "搜尋文章…",
      "searchLabel": "搜尋文章",
      "all": "全部",
      "empty": "暫時未有符合篩選條件的文章。",
      "readMore": "閱讀更多",
      "authorFallback": "BidNova"
    },
    "detail": {
      "authorFallback": "BidNova 團隊",
      "backLink": "返回所有文章"
    }
  },
  "events": {
    "communityIndex": {
      "title": "英國卡展日曆",
      "subtitle": "全英各地的集換卡展、比賽、交易之夜、送評活動及收藏家聚會。",
      "empty": "暫時未有活動 — 請留意後續更新。"
    },
    "publicIndex": {
      "eyebrow": "社群",
      "title": "即將舉行的卡展與活動",
      "subtitle": "全英各地的集換卡展、比賽、交易之夜、送評活動及收藏家聚會。",
      "empty": "暫時未有活動 — 請留意後續更新。"
    },
    "card": {
      "featured": "精選",
      "viewDetails": "查看詳情"
    },
    "detail": {
      "recurring": "定期舉行",
      "days": "日",
      "hours": "小時",
      "minutes": "分鐘",
      "when": "時間",
      "where": "地點",
      "openInMaps": "以地圖開啟",
      "rsvp": "確認出席",
      "getTickets": "購買門票",
      "visitWebsite": "瀏覽網站",
      "organisedBy": "主辦方：{name}"
    },
    "section": {
      "eyebrow": "社群",
      "title": "英國卡展預告",
      "viewAll": "查看所有活動 →"
    }
  },
  "dealers": {
    "index": {
      "title": "商戶名錄",
      "subtitle": "信譽良好的英國卡店、玩具店、送評服務與網店。",
      "searchPlaceholder": "以名稱、城鎮或郵政編碼搜尋…",
      "searchLabel": "搜尋商戶",
      "typeLabel": "類型",
      "gameLabel": "遊戲",
      "all": "全部",
      "empty": "暫時未有符合篩選條件的商戶。",
      "featured": "精選",
      "visitWebsite": "瀏覽網站"
    },
    "detail": {
      "featured": "精選",
      "contact": "聯絡方式",
      "website": "網站",
      "openingHours": "營業時間",
      "backLink": "返回商戶名錄"
    }
  },
  "updates": {
    "eyebrow": "社群",
    "title": "最新社群動態",
    "featured": "精選",
    "readMore": "閱讀更多",
    "communityUpdateAlt": "BidNova 社群動態"
  },
  "partners": {
    "index": {
      "eyebrow": "合作夥伴名錄",
      "title": "信譽良好的 BidNova 合作夥伴",
      "subtitle": "以下每個合作夥伴均經 BidNova 團隊審核及批准 — 涵蓋卡店、送評公司以至物流及保險專家。",
      "becomePartner": "成為合作夥伴 →",
      "searchPlaceholder": "以名稱、簡介或地區搜尋合作夥伴…",
      "searchLabel": "搜尋合作夥伴",
      "verifiedOnly": "只顯示已驗證",
      "resultsCount": "{count, plural, other {# 個結果}}",
      "all": "全部",
      "loading": "正在載入合作夥伴…",
      "empty": "暫時未有符合篩選條件的合作夥伴。"
    },
    "detail": {
      "loading": "載入中…",
      "unavailable": "此合作夥伴資料暫時無法顯示。",
      "notFound": "找不到此合作夥伴。",
      "website": "網站",
      "partnerSince": "合作夥伴年份：{year}",
      "contact": "聯絡方式",
      "active": "進行中",
      "sold": "已售出",
      "since": "加入年份",
      "about": "關於",
      "shipping": "運送與交付",
      "policies": "政策",
      "bidnovaShop": "BidNova 店舖",
      "alsoSells": "此合作夥伴亦於 BidNova 上開店銷售。",
      "visitShop": "前往店舖",
      "social": "社交媒體"
    },
    "apply": {
      "eyebrow": "成為合作夥伴",
      "title": "與 BidNova 一同拓展業務",
      "subtitle": "官方合作夥伴、精選商戶、送評公司及配件品牌 — 立即申請加入 BidNova 生態圈。所有合作位置現時免費，並由我們團隊精心審核。"
    }
  },
  "shops": {
    "index": {
      "eyebrow": "精選商戶",
      "title": "信譽良好的 BidNova 賣家",
      "subtitle": "以下每間店舖均經 BidNova 團隊審核及批准。",
      "directoryTitle": "所有精選商戶",
      "directoryEyebrow": "商戶目錄"
    },
    "detail": {
      "unavailable": "此店舖暫時無法顯示。",
      "notFound": "找不到此店舖。",
      "fullProfile": "查看完整資料",
      "liveAuctions": "進行中的拍賣",
      "noAuctions": "此店舖現時暫無進行中的拍賣。",
      "sales": "{count, plural, other {# 宗成交}}"
    }
  },
  "advertise": {
    "eyebrow": "合作夥伴計劃",
    "title": "在 BidNova 刊登廣告",
    "subtitlePrefix": "接觸英國最活躍的集換卡社群。在我們的啟動階段，所有廣告位置均",
    "subtitleHighlight": "完全免費",
    "subtitleSuffix": "，並由 BidNova 團隊精心策劃。",
    "freeBadge": "啟動期間免費 · 毋須信用卡",
    "mostPopular": "最受歡迎",
    "applyNow": "立即申請",
    "disclaimer": "所有廣告位置均由我們團隊人手審核，並清晰標示為「Sponsored」。BidNova 不保證特定的瀏覽量、點擊或銷售成效。",
    "faqTitle": "常見問題",
    "ctaTitle": "想直接傾談？",
    "ctaSubtitle": "告訴我們貴公司的業務，我們會為你度身訂造合作方案。",
    "ctaButton": "開始申請",
    "placements": {
      "banner": {
        "name": "主頁贊助橫額",
        "tagline": "每位訪客都會看到的優質主頁位置。",
        "b1": "主頁最頂端顯眼位置",
        "b2": "清晰標示為 Sponsored",
        "b3": "透明的曝光及點擊數據報告",
        "b4": "與少量精選合作夥伴輪流展示"
      },
      "featuredShop": {
        "name": "精選商戶",
        "tagline": "讓資深收藏家留意到你的店舖。",
        "b1": "於主頁精選商戶版面展示",
        "b2": "直接連結至你的 BidNova 賣家主頁",
        "b3": "於公開資料頁顯示已驗證標籤",
        "b4": "於分類頁面獲優先展示"
      },
      "officialPartner": {
        "name": "官方合作夥伴",
        "tagline": "加入 BidNova 官方合作夥伴網絡。",
        "b1": "標誌於官方合作夥伴輪播展示",
        "b2": "專屬公開合作夥伴主頁",
        "b3": "於通訊及社交媒體上作交叉宣傳",
        "b4": "與 BidNova 建立長期品牌連繫"
      },
      "eventSponsorship": {
        "name": "活動與客製化贊助",
        "tagline": "度身訂造的活動合作方案。",
        "b1": "比賽、活動及獎品贊助",
        "b2": "客製化主頁全版展示",
        "b3": "整合式編輯專題內容",
        "b4": "按你的品牌及受眾度身訂造"
      }
    },
    "faqs": {
      "q1": {
        "q": "收費是多少？",
        "a": "BidNova 現正拓展合作夥伴網絡，廣告位置暫時全部免費。如日後有任何變動，我們團隊會提前通知你。"
      },
      "q2": {
        "q": "我的廣告會展示在哪裡？",
        "a": "展示位置包括主頁贊助位、精選商戶版面、官方合作夥伴輪播，或與我們團隊協定的客製化合作方案。"
      },
      "q3": {
        "q": "曝光量及點擊如何計算？",
        "a": "只有當廣告位置進入可視範圍時才會計算曝光，而點擊則由伺服器端記錄並附有防重複機制，不會儲存任何個人識別資料。"
      },
      "q4": {
        "q": "可以提供客製化贊助方案嗎？",
        "a": "可以 — 活動贊助、客製化主頁展示及整合式合作方案均可安排。歡迎於申請表格中告訴我們你的構思。"
      }
    },
    "apply": {
      "eyebrow": "與 BidNova 合作宣傳",
      "title": "贊助英國頂級集換卡市場",
      "subtitle": "告訴我們貴公司的業務，以及你希望如何接觸 BidNova 的收藏家社群。所有位置均由我們團隊精心審核 — 毋須信用卡。"
    }
  },
  "featuredShops": {
    "eyebrow": "精選賣家",
    "title": "精選商戶",
    "browseAll": "瀏覽所有商戶 →",
    "live": "進行中",
    "sold": "已售出",
    "rating": "評分",
    "newSeller": "新賣家",
    "new": "新",
    "sales": "成交",
    "visitShop": "前往店舖",
    "viewShop": "查看店舖",
    "noneInCategory": "此分類暫時未有商戶。",
    "all": "全部",
    "verifiedAlt": "已驗證賣家",
    "sellerFallback": "BidNova 賣家"
  },
  "partnerCarousel": {
    "eyebrow": "業界信賴之選",
    "title": "信譽合作夥伴",
    "verifiedAlt": "已驗證",
    "officialPartnerSuffix": " — 官方合作夥伴"
  },
  "becomePartnerCta": {
    "eyebrow": "合作夥伴網絡",
    "headlineDefault": "與 BidNova Auctions 一同拓展業務",
    "descriptionDefault": "宣傳你的業務、成為精選商戶，或加入 BidNova 官方合作夥伴網絡。",
    "becomePartner": "成為合作夥伴",
    "advertiseWithUs": "與我們合作宣傳",
    "closed": "申請現已暫停接受，請稍後再留意。"
  },
  "newsletter": {
    "eyebrow": "電子報",
    "title": "加入 BidNova 社群",
    "subtitle": "掌握最新拍賣、精選卡片、合作夥伴優惠、卡展及市場資訊。",
    "emailPlaceholder": "you@example.com",
    "emailLabel": "電郵地址",
    "subscribe": "訂閱",
    "subscribing": "訂閱中…",
    "consentLabel": "我同意接收 BidNova 電郵",
    "consentPrefix": "我同意接收 BidNova Auctions 的宣傳電郵，並可隨時取消訂閱。詳情請參閱我們的",
    "privacyLink": "私隱政策",
    "consentError": "請剔選同意方格以繼續。",
    "genericError": "發生錯誤，請重試。",
    "successTitle": "你已成功登記",
    "successBody": "請留意你的電郵信箱，接收 BidNova 拍賣精選及社群資訊。"
  },
  "partnerForm": {
    "types": {
      "featuredShop": "精選商戶",
      "officialPartner": "官方合作夥伴",
      "homepageAdvertising": "主頁贊助",
      "eventSponsor": "活動合作夥伴",
      "gradingCompany": "送評公司",
      "accessoriesStore": "配件商店",
      "custom": "其他"
    },
    "consentRequired": "請先接受條款以繼續。",
    "genericError": "發生錯誤",
    "successTitle": "已收到申請",
    "successBody": "多謝你有興趣與 BidNova Auctions 合作。我們團隊將審核你的申請，並會以電郵與你聯絡。",
    "backToHome": "返回主頁",
    "applicationsClosed": "申請現已暫停接受。你仍可填寫表格，但提交將於重開後才會處理。",
    "sectionBusiness": "業務資料",
    "sectionSocial": "社交媒體",
    "sectionApplication": "申請詳情",
    "sectionBrief": "廣告簡介",
    "fields": {
      "businessName": "業務名稱 *",
      "contactName": "聯絡人姓名 *",
      "businessEmail": "業務電郵 *",
      "contactPhone": "聯絡電話",
      "website": "網站",
      "businessType": "業務類型 *",
      "country": "國家",
      "instagram": "Instagram",
      "facebook": "Facebook",
      "discord": "Discord",
      "applicationType": "申請類型 *",
      "existingSeller": "現有 BidNova 賣家用戶名（如適用）",
      "logoUrl": "標誌圖片網址",
      "bannerUrl": "橫幅圖片網址（如適用）",
      "requestedPlacement": "希望的展示位置",
      "noPreference": "沒有特別要求",
      "estimatedBudget": "預計預算（£）",
      "requestedStart": "希望開始日期",
      "requestedEnd": "希望結束日期",
      "advertisingGoal": "宣傳目標",
      "advertisingGoalPlaceholder": "你希望這次宣傳達到甚麼成效？",
      "description": "簡介",
      "services": "提供的服務",
      "notes": "備註"
    },
    "consentPrefix": "我同意 BidNova Auctions 的",
    "consentMiddle": "及",
    "consentSuffix": "，並同意就此申請被聯絡。",
    "termsLink": "使用條款",
    "privacyLink": "私隱政策",
    "submit": "提交申請",
    "submitting": "提交中…"
  }
}
